import React from 'react';
import PropTypes from 'prop-types';
import classNames from "classnames";

import ModalConfirm from "UI/ModalConfirm";
import Dropdown from "UI/Dropdown";

export default class IntegrationOptions extends React.Component
{
    state = {
        showDeleteModal: false
    };

    static propTypes = {
        integration: PropTypes.object.isRequired,
        onDisconnect: PropTypes.func.isRequired,
    };

    render()
    {
        const onClose = () => this.setState({showDeleteModal: false});
        const onConfirm = () => this.props.onDisconnect(this.props.integration.id);

        return <>
            <Dropdown button={Dropdown.VerticalDotsButton} origin='tr'>
                <Dropdown.AnchorItem href={this.props.integration.link} target='_blank'>
                    Visit profile
                </Dropdown.AnchorItem>
                <Dropdown.Item danger onClick={() => this.setState({showDeleteModal: true})}>
                    Disconnect
                </Dropdown.Item>
            </Dropdown>

            <ModalConfirm danger open={this.state.showDeleteModal} onClose={onClose} onConfirm={onConfirm}>
                <p>Are you sure you wish to disconnect this Integration?</p>
                <p>All scheduled posts will be unscheduled and moved to drafts.</p>
            </ModalConfirm>
        </>;
    }
}
